import type { RepDisciplineReason } from "./repDiscipline";

export interface RepDeactivationDetails {
	RepresentativeId: number;
	DeactivationType?: RepDeactivationTypes;
	DeactivationReason?: string;
	DisciplineSource?: RepDisciplineReason;
	DisciplineReason?: string;
	DisciplineDate?: Date;
	DisciplineEndDate?: Date;
	EffectiveDate?: Date;
}

export enum RepDeactivationTypes {
	Deactivated = 1,
	Suspended,
	Terminated,
	Blocklisted,
	Denied,
}
